
  const packingSlip = {
    path: "/worksheet/packing-check/:id",
    name: "worksheetPackingCheck",
    component: () => import(/* webpackChunkName: "packing-slip" */ "@/components/packaging/PackingCheck.vue"),
    meta: { authorize: [], requiresAuth: true }
  };

export default packingSlip;
    